export default function SectionHeading({ overline, title, subtitle, align = "left", as = "h2" }) {
  const Tag = as;
  return (
    <div className={`${align === "center" ? "text-center mx-auto max-w-3xl" : "max-w-3xl"}`}>
      {overline && (
        <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#99582A]">
          {overline}
        </p>
      )}
      <Tag className="font-display text-4xl md:text-5xl tracking-tight font-medium text-[#111] mt-4">
        {title}
      </Tag>
      {subtitle && (
        <p className="mt-5 text-base md:text-lg text-[#4A4A4A] leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
}
